export enum BarringConnectedServiceStatuses {
  ACTIVE='ACTIVE',
  TEMPORARY_BARRING='TEMPORARY_BARRING',
  PROCESSING='PROCESSING'
}
